var _circle, _g, _circle2, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeProcedimentos = function SvgIconeProcedimentos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_14652_31337)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#FCCE74"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14652_31337",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 17.8,
    r: 12,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14652_31337)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9461 10.098C22.3628 9.36601 19.7796 9 17.1964 9C14.6136 9 12.0326 9.3659 9.45331 10.0977C8.82885 10.2749 8.39994 10.8284 8.3999 11.4572V19.7871C8.3999 19.8147 8.40075 19.8424 8.40245 19.87C8.44987 20.6425 9.13649 21.2316 9.93606 21.1857L12.8168 20.7111C12.8168 20.691 14.1368 20.4533 15.9303 20.3668C15.9418 20.355 15.9533 20.3432 15.9648 20.3316L21.3502 14.9658C22.4058 13.9082 24.5107 13.4799 25.9999 14.9325V11.4577C25.9999 10.8287 25.5707 10.2751 24.9461 10.098ZM25.9999 19.6965L24.5044 21.1866L24.5063 21.1866L24.5332 21.1869C25.3433 21.1869 25.9999 20.5525 25.9999 19.7699V19.6965Z",
    fill: "#FFEED6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0765 11.6399V13.403L19.8399 13.4065V15.1631L18.0765 15.1633V16.9199H16.3197V15.1631H14.5599V13.4065H16.3197V11.6399H18.0765Z",
    fill: "#866600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter2_d_14652_31337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1502 16.7659L16.7649 22.1317C15.7003 23.1982 15.2738 25.3318 16.7649 26.8257C18.2559 28.3195 20.4073 27.9145 21.4514 26.8257L26.8361 21.4605C27.9 20.3958 28.3254 18.2609 26.8349 16.7671C25.3438 15.2733 23.2142 15.7 22.1502 16.7659ZM21.6273 20.6927C21.5713 20.6367 21.527 20.5701 21.4967 20.4968C21.4665 20.4236 21.4509 20.3451 21.4509 20.2658C21.451 20.1865 21.4666 20.108 21.4969 20.0348C21.5272 19.9616 21.5716 19.895 21.6276 19.839C21.6836 19.783 21.75 19.7385 21.8231 19.7082C21.8962 19.6779 21.9746 19.6623 22.0537 19.6623C22.1329 19.6624 22.2112 19.678 22.2843 19.7084C22.3574 19.7387 22.4238 19.7832 22.4798 19.8393C22.5927 19.9525 22.6562 20.1061 22.6561 20.2662C22.656 20.4263 22.5925 20.5799 22.4795 20.693C22.3664 20.8062 22.2131 20.8698 22.0533 20.8697C21.8935 20.8697 21.7402 20.806 21.6273 20.6927ZM22.9057 21.9735C22.8482 21.9179 22.8023 21.8513 22.7707 21.7776C22.7391 21.704 22.7225 21.6248 22.7218 21.5446C22.7211 21.4645 22.7363 21.385 22.7666 21.3108C22.7969 21.2367 22.8417 21.1693 22.8982 21.1126C22.9548 21.0559 23.0221 21.0111 23.0961 20.9808C23.1701 20.9504 23.2495 20.9351 23.3295 20.9358C23.4095 20.9365 23.4885 20.9532 23.562 20.9848C23.6355 21.0164 23.702 21.0624 23.7576 21.1201C23.8673 21.2339 23.928 21.3864 23.9267 21.5446C23.9253 21.7029 23.8619 21.8543 23.7502 21.9662C23.6385 22.0781 23.4874 22.1416 23.3295 22.1429C23.1715 22.1443 23.0193 22.0835 22.9057 21.9735ZM19.9235 22.4003C19.866 22.3446 19.8201 22.278 19.7885 22.2043C19.757 22.1307 19.7403 22.0515 19.7396 21.9714C19.7389 21.8912 19.7542 21.8117 19.7845 21.7376C19.8148 21.6634 19.8595 21.596 19.9161 21.5393C19.9726 21.4827 20.0399 21.4378 20.1139 21.4075C20.188 21.3771 20.2673 21.3619 20.3473 21.3626C20.4273 21.3633 20.5064 21.3799 20.5799 21.4115C20.6534 21.4432 20.7198 21.4892 20.7754 21.5468C20.8852 21.6606 20.9459 21.8131 20.9445 21.9714C20.9431 22.1296 20.8798 22.281 20.7681 22.3929C20.6564 22.5048 20.5053 22.5683 20.3473 22.5697C20.1893 22.571 20.0372 22.5102 19.9235 22.4003ZM21.2013 23.6804C21.0884 23.5672 21.025 23.4136 21.025 23.2535C21.0251 23.0934 21.0886 22.9399 21.2016 22.8267C21.3147 22.7135 21.468 22.65 21.6278 22.65C21.7876 22.6501 21.9409 22.7137 22.0538 22.827C22.1668 22.9402 22.2302 23.0938 22.2302 23.2539C22.2301 23.3332 22.2145 23.4117 22.1842 23.4849C22.1539 23.5582 22.1095 23.6247 22.0535 23.6807C21.9975 23.7368 21.9311 23.7812 21.858 23.8115C21.7849 23.8418 21.7065 23.8574 21.6274 23.8574C21.4676 23.8573 21.3143 23.7937 21.2013 23.6804Z",
    fill: "#FFEED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9235 22.4003C19.866 22.3446 19.8201 22.278 19.7885 22.2043C19.757 22.1307 19.7403 22.0515 19.7396 21.9714C19.7389 21.8912 19.7542 21.8117 19.7845 21.7376C19.8148 21.6634 19.8595 21.596 19.9161 21.5393C19.9726 21.4827 20.0399 21.4378 20.1139 21.4075C20.188 21.3771 20.2673 21.3619 20.3473 21.3626C20.4273 21.3633 20.5064 21.3799 20.5799 21.4115C20.6534 21.4432 20.7198 21.4892 20.7754 21.5468C20.8852 21.6606 20.9459 21.8131 20.9445 21.9714C20.9431 22.1296 20.8798 22.281 20.7681 22.3929C20.6564 22.5048 20.5053 22.5683 20.3473 22.5697C20.1893 22.571 20.0372 22.5102 19.9235 22.4003Z",
    fill: "#FFEED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2013 23.6804C21.0884 23.5672 21.025 23.4136 21.025 23.2535C21.0251 23.0934 21.0886 22.9399 21.2016 22.8267C21.3147 22.7135 21.468 22.65 21.6278 22.65C21.7876 22.6501 21.9409 22.7137 22.0538 22.827C22.1668 22.9402 22.2302 23.0938 22.2302 23.2539C22.2301 23.3332 22.2145 23.4117 22.1842 23.4849C22.1539 23.5582 22.1095 23.6247 22.0535 23.6807C21.9975 23.7368 21.9311 23.7812 21.858 23.8115C21.7849 23.8418 21.7065 23.8574 21.6274 23.8574C21.4676 23.8573 21.3143 23.7937 21.2013 23.6804Z",
    fill: "#FFEED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9057 21.9735C22.8482 21.9179 22.8023 21.8513 22.7707 21.7776C22.7391 21.704 22.7225 21.6248 22.7218 21.5446C22.7211 21.4645 22.7363 21.385 22.7666 21.3108C22.7969 21.2367 22.8417 21.1693 22.8982 21.1126C22.9548 21.0559 23.0221 21.0111 23.0961 20.9808C23.1701 20.9504 23.2495 20.9351 23.3295 20.9358C23.4095 20.9365 23.4885 20.9532 23.562 20.9848C23.6355 21.0164 23.702 21.0624 23.7576 21.1201C23.8673 21.2339 23.928 21.3864 23.9267 21.5446C23.9253 21.7029 23.8619 21.8543 23.7502 21.9662C23.6385 22.0781 23.4874 22.1416 23.3295 22.1429C23.1715 22.1443 23.0193 22.0835 22.9057 21.9735Z",
    fill: "#FFEED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6273 20.6927C21.5713 20.6367 21.527 20.5701 21.4967 20.4968C21.4665 20.4236 21.4509 20.3451 21.4509 20.2658C21.451 20.1865 21.4666 20.108 21.4969 20.0348C21.5272 19.9616 21.5716 19.895 21.6276 19.839C21.6836 19.783 21.75 19.7385 21.8231 19.7082C21.8962 19.6779 21.9746 19.6623 22.0537 19.6623C22.1329 19.6624 22.2112 19.678 22.2843 19.7084C22.3574 19.7387 22.4238 19.7832 22.4798 19.8393C22.5927 19.9525 22.6562 20.1061 22.6561 20.2662C22.656 20.4263 22.5925 20.5799 22.4795 20.693C22.3664 20.8062 22.2131 20.8698 22.0533 20.8697C21.8935 20.8697 21.7402 20.806 21.6273 20.6927Z",
    fill: "#FFEED6"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0149 16.8911L16.8912 22.0227L21.5706 26.7093L26.7094 21.581C26.6943 21.5961 22.0149 16.8911 22.0149 16.8911ZM21.4479 20.5405C21.4781 20.6139 21.5225 20.6805 21.5784 20.7367C21.6913 20.8501 21.8445 20.9138 22.0043 20.9138C22.1641 20.9139 22.3173 20.8503 22.4303 20.737C22.5433 20.6236 22.6068 20.4699 22.6069 20.3096C22.6069 20.1493 22.5435 19.9956 22.4306 19.8822C22.3747 19.826 22.3083 19.7815 22.2352 19.7511C22.1622 19.7207 22.0838 19.705 22.0047 19.705C21.9256 19.705 21.8473 19.7206 21.7742 19.7509C21.7011 19.7813 21.6347 19.8258 21.5787 19.8819C21.5227 19.938 21.4784 20.0046 21.4481 20.0779C21.4178 20.1512 21.4021 20.2298 21.4021 20.3092C21.4021 20.3886 21.4176 20.4672 21.4479 20.5405ZM22.7214 21.8228C22.753 21.8966 22.7989 21.9633 22.8564 22.019C22.97 22.1291 23.1221 22.19 23.28 22.1886C23.438 22.1872 23.589 22.1237 23.7007 22.0116C23.8123 21.8996 23.8757 21.748 23.8771 21.5896C23.8784 21.4311 23.8177 21.2785 23.708 21.1645C23.6525 21.1068 23.586 21.0608 23.5125 21.0291C23.439 20.9974 23.36 20.9807 23.28 20.98C23.2001 20.9793 23.1208 20.9946 23.0468 21.025C22.9727 21.0554 22.9055 21.1003 22.8489 21.157C22.7924 21.2138 22.7477 21.2812 22.7174 21.3555C22.6871 21.4298 22.6719 21.5093 22.6726 21.5896C22.6733 21.6698 22.6899 21.7491 22.7214 21.8228ZM19.7402 22.2501C19.7718 22.3238 19.8177 22.3905 19.8752 22.4462C19.9888 22.5563 20.1409 22.6172 20.2988 22.6159C20.4567 22.6145 20.6078 22.5509 20.7195 22.4389C20.8311 22.3268 20.8945 22.1753 20.8958 22.0168C20.8972 21.8584 20.8365 21.7057 20.7268 21.5918C20.6712 21.534 20.6048 21.488 20.5313 21.4563C20.4578 21.4247 20.3788 21.408 20.2988 21.4073C20.2189 21.4066 20.1396 21.4219 20.0655 21.4523C19.9915 21.4827 19.9243 21.5275 19.8677 21.5843C19.8112 21.641 19.7665 21.7085 19.7362 21.7827C19.7059 21.857 19.6907 21.9366 19.6914 22.0168C19.6921 22.0971 19.7087 22.1764 19.7402 22.2501ZM20.9763 23.3005C20.9763 23.4608 21.0397 23.6146 21.1526 23.728C21.2655 23.8414 21.4187 23.9051 21.5785 23.9052C21.6576 23.9052 21.7359 23.8896 21.809 23.8592C21.8821 23.8289 21.9485 23.7844 22.0045 23.7283C22.0605 23.6722 22.1049 23.6056 22.1352 23.5322C22.1655 23.4589 22.1811 23.3803 22.1811 23.3009C22.1811 23.1406 22.1177 22.9869 22.0048 22.8735C21.8919 22.7601 21.7387 22.6964 21.5789 22.6963C21.4192 22.6962 21.2659 22.7599 21.1529 22.8732C21.0399 22.9865 20.9764 23.1402 20.9763 23.3005Z",
    fill: "#9B7700"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31337",
    x: 0.888889,
    y: 0.444444,
    width: 34.2222,
    height: 34.2222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.555556
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.555556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.709804 0 0 0 0 0.545098 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31337",
    x: 7.3999,
    y: 8,
    width: 19.6,
    height: 14.1882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.835294 0 0 0 0 0.643137 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31337",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_14652_31337",
    x: 14.7999,
    y: 15.1788,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.378788
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.709804 0 0 0 0 0.545098 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31337"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31337",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeProcedimentos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-procedimentos.4527c2a5.svg";
export { ForwardRef as ReactComponent };